<template lang="pug">
  v-container
    v-row
      v-col
        v-subheader.mt-4 Assos aléatoires
        utility-action-state(:action="changeRandomAssociation")
          template(#default="{ loading, trigger }")
            v-row(wrap)
              v-col(:cols="12")
                v-card
                  v-card-text
                    v-row.align-center(dense)
                      v-col.shrink
                        feature-avatar.mr-4(
                          :size="100 / $goldenRatio"
                          v-shared-element:heroId="{ includeChildren: true, ignoreTransparency: true }"
                          :lazy-src="$get(randomAssociation, `user.image.srcLazy`)"
                          :src="$get(randomAssociation, `user.image.src`)"
                          @click="goToRandomAssociation")
                      v-col
                        v-row(
                          :disabled="loading"
                          @click="goToRandomAssociation")
                          v-col.text-truncate(style="font-size: 22px") {{ $get(randomAssociation, `user.name`, '\xa0') }}
                        v-row.align-center.mt-2
                          v-col.text-center.pt-0(:cols="14")
                          v-col
                            v-btn.elevation-2(
                              @click="$createOnClick({ onClickRandomAffiliation: trigger })"
                              :ripple="false"
                              :disabled="loading"
                              fab
                              small)
                              v-icon {{ mdiRefresh }}
                          v-col(v-if="!isUserBlocked")
                            utility-action-state(:action="() => doSupport({ supportedAssociationId: $get(randomAssociation, `id`) })")
                              template(#default="{ loading, trigger }")
                                v-btn(
                                  @click="$createOnClick({ onClickRandomAsso: trigger })"
                                  :loading="loading"
                                  outlined
                                  rounded
                                  :disabled="loading"
                                  block) Soutenir
        template(v-if="randomAffiliation && !isUserBlocked")
          v-subheader.mt-4 Partenaires
          utility-action-state(:action="changeRandomAffiliation")
            template(#default="{ loading, trigger }")
              v-row(wrap)
                v-col(:cols="12")
                  v-card
                    v-card-text
                      v-row.align-center(dense)
                        v-col.shrink
                          feature-avatar.mr-4(
                            :size="100 / $goldenRatio"
                            v-shared-element:heroId="{ includeChildren: true, ignoreTransparency: true }"
                            :lazy-src="$get(randomAffiliation, `image.srcLazy`)"
                            :src="$get(randomAffiliation, `image.src`)"
                            )
                        v-col
                          v-row
                            v-col.text-truncate(style="font-size: 22px") {{ $get(randomAffiliation, `name`, '\xa0') }}
                          v-row
                            v-col.textarea-truncate.pt-4(
                              line-count="3",
                              style="font-size: 14px") {{ $get(randomAffiliation, `message`, '\xa0') }}
                      v-row(v-if="$get(randomAffiliation, `codePromo`, '\xa0')")
                        v-col.textarea-truncate.pt-4(
                              line-count="3",
                              style="font-size: 14px") code promo :
                        v-col.textarea-truncate.pt-4(
                          line-count="3",
                          style="font-size: 18px") {{ $get(randomAffiliation, `codePromo`, '\xa0') }}
                      v-row.align-center.mt-2
                        v-col
                        v-col.text-center.pt-0(:cols="14")
                        v-col
                          v-btn.elevation-2(
                            @click="$createOnClick({ onClickRandomAffiliation: trigger })"
                            :ripple="false"
                            :disabled="loading"
                            fab
                            small)
                            v-icon {{ mdiRefresh }}
                        v-col
                          v-btn(
                            @click="$createOnClick({ goToExternalUrl })") Visiter
    v-subheader.mt-4 Catégories
    v-row(
      dense
      wrap)
      v-col(
        v-for="theme in themes"
        :key="theme.id"
        :cols="6")
        v-card(
          @click="$createOnClick({ goToTheme }, { id: theme.id, name: theme.name })")
          v-img.white--text.align-center.justify-center(
            :height="100"
            gradient="to top right, rgba(100,115,201,.88), rgba(25,32,72,.7)"
            :lazy-src="theme.image.srcLazy"
            :src="theme.image.src")
            div(
              style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: -1; opacity: 0.2;"
              :style="{ background: theme.color }")
            div.text-center.px-4(style="font-size: 18px") {{ theme.name }}
</template>

<script>
import { page } from '@iez/core'
import { mdiHome, mdiMagnify, mdiHeart, mdiRefresh } from '@mdi/js'
import data from '@iez/lib/data/'
import UtilityActionState from '@iez/components/utility/action-state/'
import router from '@iez/core/router/'
import user from '@iez/lib/user/'
//import affiliation from '@iez/lib/affiliation/'
import $goToExternalUrl from '@iez/lib/go-to-external-url/'
import { ref } from '@vue/composition-api'
import waitFor from '@iez/lib/wait-for/'
import image from './image.jpg'
import { addOverflowDependency } from '@iez/core/router/'
import doSupport from '@/shared/do-support/'
import SocialNetworkRandomEntity from '@iez/components/social-network/random-entity/'
import createOnClick from '@iez/lib/create-on-click/'
import isUserBlocked from '@/shared/is-user-blocked/'

const route = {
  name: 'Home',
  path: '/'
}

page.bottomNavigation.add({
  route,
  icon: mdiHome,
  position: 2
})

export default {
  ...route,

  components: {
    UtilityActionState,
    SocialNetworkRandomEntity
  },

  setup () {
    /*page.topBar.set({
      search: true,
      root: true
    })*/
    const seed = ref(Math.random())
    const seedAffiliation = ref(Math.random())
    const lastRandomAssociationId = ref(null)

    const lastRandomAffiliationId = ref(null)

    const currentLoadingStates = ref(0)

    const goToExternalUrl = () => {
      data.update({
        root: `affiliations`,
        id: randomAffiliation.value.id,
        _set: {
          countLink: randomAffiliation.value.countLink + 1
        },
        fields: [
          `id`,
          `link`,
          `CountLink`,
        ]
      })
      $goToExternalUrl({ url: randomAffiliation.value.link })
    }

    page.blockingProgression.set(
      () => currentLoadingStates.value > 0
        ? {
          isActive: true
        } : false
    )

    const me = data.me({
      fields: [
        `id`, {
          association: [
            `id`
          ]
        }
      ]
    })


    const randomAssociation = data.get({
      root: `associations`,
      random: true,
      one: true,
      fetchPolicy: `network-only`,
      fields: [
        `id`, {
          user: [
            `id`,
            `name`, {
              image: [
                `id`,
                `src`,
                `srcLazy`
              ]
            }
          ]
        }
      ],
      request: () => ({
        args: {
          seed: `${seed.value}`
        },
        ...lastRandomAssociationId.value
          ? {
            where: {
              _and: {
                id: {
                  _nin: [lastRandomAssociationId.value, me.value?.association?.id].filter(Boolean)
                },
                user: {
                  name: {
                    _is_null: false
                  }
                }
              }
            }
          } : {
            where: {
              user: {
                id: {
                  _is_null: false
                }
              }
            }
          }
      })
    })

    const changeRandomAssociation = () => {
      seed.value = Math.random()
      lastRandomAssociationId.value = randomAssociation.value.id
      randomAssociation.value = null

      return waitFor({
        dependencies: () => randomAssociation.value
      })
    }

    const randomAffiliation = data.get({
      root: `affiliations`,
      random: true,
      one: true,
      fetchPolicy: `network-only`,
      fields: [
        `id`,
        `name`,
        `link`,
        `codePromo`,
        //`test`,
        `message`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ]
        }
      ],
      request: () => ({
        args: {
          seed: `${seedAffiliation.value}`
        },
        ...lastRandomAffiliationId.value
          ? {
            where: {
              id: {
                _neq: lastRandomAffiliationId.value
              }
            }
          } : null
      })
    })
    console.log(
      randomAffiliation
    )

    const changeRandomAffiliation = () => {
      seedAffiliation.value = Math.random()
      lastRandomAffiliationId.value = randomAffiliation.value.id
      randomAffiliation.value = null

      return waitFor({
        dependencies: () => randomAffiliation.value
      })
    }

    const themes = data.get({
      root: `themes`,
      fields: [
        `id`,
        `name`,
        `color`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ]
        }
      ],
      request: {
        order_by: {
          name: `asc`
        }
      }
    })
    page.bottomShortcut.add(
      () =>
        isUserBlocked.value
          ? null
          : {
            pages: [
              route.name
            ],
            action: {
              icon: mdiHeart,
              label: `Soutenir Yako`,
              onClick: createOnClick(
                async () => {
                  currentLoadingStates.value++
                  const yako = data.get({
                    root: `associations`,
                    fields: [`id`],
                    one: true,
                    isCalledFromComponent: false,
                    request: {
                      where: {
                        user: {
                          name: {
                            _eq: `Yako`
                          }
                        }
                      }
                    }
                  })
                  const { id: supportedAssociationId } = await waitFor({
                    dependencies: () => yako.value
                  })
                  await doSupport({
                    supportedAssociationId
                  })
                  currentLoadingStates.value--
                }
              )
            }
          }
    )

    addOverflowDependency({
      dependency: () => themes.value
    })

    const goToRandomAssociation = () => {
      const { id } = randomAssociation.value.user
      const isMe = id === user.id
      router.push({
        name: `Profile`,
        ...!isMe
          ? {
            params: {
              id
            },
            query: {
              heroIdProfileAvatar: `heroId`
            }
          } : null
      })
    }

    const goToTheme = ({ id }) => {
      router.push({
        name: `ExploreTheme`,
        params: {
          id
        }
      })
    }

    return {
      mdiMagnify,
      themes,
      goToExternalUrl,
      randomAssociation,
      randomAffiliation,
      mdiRefresh,
      changeRandomAssociation,
      changeRandomAffiliation,
      goToRandomAssociation,
      image,
      doSupport,
      goToTheme,
      isUserBlocked
    }
  }
}
</script>
